<div class="main-wrap">
    <div class="main-container">
        <p-toast></p-toast>
        Link for import: https://languesvivantes-bruges.com/api/open/csv/f792d396-b809-4c3a-8050-fcec315c915b
        <div class="first-box">
            <a [href]="trustedUrl" download="config.txt" *ngIf="downloadUrl">
                <button>Download config file from server</button>
            </a>
        </div>
        <div class="third-box">
            <textarea cols="90" rows="30" [(ngModel)]="textInput"></textarea>
            <div>
                <p>
                    Import config file (it will replace input area)
                </p>
                <input type="file" accept=".csv, .txt" (change)="handleFileInput($event)">
            </div>

            <button (click)="sendTextInput()">Update from input area</button>
        </div>
        <div class="merge-container">
            <textarea placeholder="Paste here config text to merge" cols="90" rows="30" [(ngModel)]="inputB"></textarea>
            <div class="merge-button-wrap">
                <button (click)="merge()">Fusion... Ha!</button>
            </div>

            <textarea placeholder="Merge result goes here." cols="90" rows="30" [(ngModel)]="output"></textarea>
        </div>

    </div>
</div>